var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVacantland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 20,
    viewBox: "0 0 38 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3337 0L15.3003 9.38333L17.3837 12.1667L22.3337 5.55L30.667 16.6667H16.567L9.88366 7.71667L0.666992 20H37.3337L22.3337 0ZM7.33366 16.6667L9.86699 13.2833L12.4003 16.6667H7.33366Z",
    fill: "#C0C0C0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacantland);
export default __webpack_public_path__ + "static/media/vacantland.2d578a624d8494e142c0ac1d4576fcb4.svg";
export { ForwardRef as ReactComponent };